function filterShopifyEvent(event, domElement, callback) {
  let executeCallback = false;
  if (event.type.includes("shopify:section")) {
    if (
      domElement.hasAttribute("data-section-id") &&
      domElement.getAttribute("data-section-id") === event.detail.sectionId
    )
      executeCallback = true;
  } else if (
    event.type.includes("shopify:block") &&
    event.target === domElement
  ) {
    executeCallback = true;
  }
  if (executeCallback) callback(event);
}

// is in viewport
function inViewport(elem, callback, options = {}) {
  return new IntersectionObserver((entries) => {
    entries.forEach((entry) => callback(entry));
  }, options).observe(document.querySelector(elem));
}

/* How to inViewport
document.addEventListener("DOMContentLoaded", () => {
    inViewport('[data-inviewport]', element => {
        if (!element.isIntersecting) { document.querySelector('#add2cart-cta').classList.add('active') } 
        else { document.querySelector('#add2cart-cta').classList.remove('active') }
    });
});
*/

// Toggle Body Class
let toggleBodyClass = function (arg) {
  document.body.classList.toggle(arg);
};
// Get Element Height
function getElementHeight(targetElement, appendTo, cssVar) {
  let element = document.querySelector(targetElement);

  if (element) {
    let elementHeight = element.offsetHeight;
    document
      .querySelector(appendTo)
      .style.setProperty(cssVar, `${elementHeight}px`);
  }
}

// first we get the viewport height and we multiple it by 1% to get a value for a vh unit
const getSetVh = () => {
  const roundedVh = Math.round(window.innerHeight * 0.01);
  document.body.style.setProperty("--vh", `${roundedVh}px`);
};
window.addEventListener("resize", getSetVh);

// Toggle
let toggleClass = function (qSelectors, bodyClass) {
  document
    .querySelectorAll(qSelectors)
    .forEach((e) =>
      e.addEventListener("click", () => toggleBodyClass(bodyClass)),
    );
};
// Menu
let toggleMenu = function () {
  toggleClass(".fire-menu, .shrink-menu", "open-menu");
};

// Cart
let toggleCart = function () {
  let cartElements = document.querySelectorAll(".carto, .cartc");

  // Toggle class function
  let toggle = function (element) {
    document.body.classList.toggle("open-cart");
  };

  cartElements.forEach((element) => {
    element.addEventListener("click", () => {
      toggle(element);
      document.body.classList.remove("hideheader");
    });

    // Adding the keydown event
    element.addEventListener("keydown", (e) => {
      if (
        e.key === "Enter" ||
        e.keyCode === 13 ||
        e.key === " " ||
        e.code === "Space" ||
        e.keyCode === 32 ||
        e.key === "Escape"
      ) {
        e.preventDefault(); // Prevent the default action (Scrolling page on space key)
        toggle(element);
        document.body.classList.remove("hideheader");
      }
    });
  });

  // Close cart drawer on click outside .cart (ignore the .carto open trigger)
  document.addEventListener("click", (e) => {
    if (!document.body.classList.contains("open-cart")) return;
    if (e.target.closest(".cart, .carto")) return;
    document.body.classList.remove("open-cart");
  });
};

function initializeDetailsControls() {
  // Handle dropdown menu
  const detailsElementsLv1 = document.querySelectorAll("details.lv1");
  const detailsElementsClosex = [
    ...document.querySelectorAll("details.closex"),
  ];

  function closeOtherDetails(element) {
    const detailsOpened = document.querySelectorAll("details[open].lv1");
    for (const item of detailsOpened) {
      if (element !== item) {
        item.removeAttribute("open");
      }
    }
  }

  function closeAllDetailsExcept(target) {
    detailsElementsClosex.forEach((f) =>
      !f.contains(target) ? f.removeAttribute("open") : "",
    );
    a11yDetails();
  }

  function closeAllDetails() {
    detailsElementsClosex.forEach((f) => f.removeAttribute("open"));
    a11yDetails();
  }

  // Dropdown menu
  detailsElementsLv1.forEach((item) => {
    item.addEventListener("click", function () {
      closeOtherDetails(this);
    });
  });

  // Close details when clicked outside
  document.addEventListener("click", function (e) {
    if (!detailsElementsClosex.some((f) => f.contains(e.target))) {
      closeAllDetails();
    } else {
      closeAllDetailsExcept(e.target);
    }
  });

  // Close details with esc key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" || e.keyCode === 27) {
      closeAllDetails();
    }
  });

  // Initial accessibility settings
  a11yDetails();
}

function a11yDetails() {
  document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute(
      "aria-expanded",
      summary.parentNode.hasAttribute("open"),
    );

    if (summary.nextElementSibling.getAttribute("id")) {
      summary.setAttribute("aria-controls", summary.nextElementSibling.id);
    }

    summary.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open"),
      );
    });
  });
}

// Filters
let closeFilters = function () {
  let filter = document.querySelector("#filter");
  let closeFilterElement = document.querySelector("#closeFilter");

  if (!closeFilterElement) return;
  closeFilterElement.addEventListener("click", function () {
    filter.removeAttribute("open");
  });
};

// update button price on variant change
function updatePrice(obj, idd) {
  var uid = obj.options[obj.selectedIndex].getAttribute("data-price");
  var pb = document.querySelector(".uprice" + idd);
  pb.innerHTML = uid;
}

function selectOptions(obj, idd) {
  updatePrice(obj, idd);
}

// Debug
if (window.location.href.indexOf("debug") > -1) {
  var OpenThinking = OpenThinking || {};
  OpenThinking.theme = {
    name: "Bullet",
    version: `${window.BOOMR.themeVersion}`,
  };
  console.log(`${OpenThinking.theme.name} v${OpenThinking.theme.version}`);
}

// AJAX cart.js
// AJAX cart init can be located in theme.liquid
function ajaxCart(obj) {
  // Show loading feedback
  obj.classList.add("loading");

  // on cart request success
  $(document).ajaxSuccess(function (event, jqxhr, settings) {
    if (settings.url == "/cart/add.js" || settings.url == "/cart/change.js") {
      // on cart request complete (just in case)
      $(document).on("cart.requestComplete", function (event, cart) {
        // Update # of items in cart
        document
          .getElementById("counter")
          .setAttribute("data-count", cart.item_count);
        // Open cart
        document.body.classList.add("open-cart");
        document.body.classList.add("hideheader");
        // Remove loading feedback
        obj.classList.remove("loading");
      });
    }
  });

  // on cart request error
  $(document).ajaxError(function (event, jqxhr, settings) {
    if (settings.url == "/cart/add.js" || settings.url == "/cart/change.js") {
      obj.classList.remove("loading"); // Remove loading feedback

      const errors = jqxhr.responseJSON.description;
      if (errors) {
        Object.values(errors).forEach((errorArray) => {
          errorArray.forEach((errorMessage) => {
            alert(errorMessage);
            console.log(errorMessage);
          });
        });
      }
    }
  });
}

// Update # of items in cart
document.addEventListener("cart.requestComplete", function (event) {
  const cart = event.detail;
  document
    .getElementById("counter")
    .setAttribute("data-count", cart.item_count);
});

// Bullet marquee
if (!customElements.get("bullet-marquee"))
  customElements.define(
    "bullet-marquee",
    class bulletMarquee extends HTMLElement {
      constructor() {
        super();
        if (window.ResizeObserver)
          new ResizeObserver(this.duration.bind(this)).observe(this);
      }

      duration(entries) {
        const scrollingSpeed = parseInt(this.getAttribute("bullet-speed") || 5);
        const contentWidth = entries[0].contentRect.width;

        // Calculate the slowFactor based on content width
        let slowFactor =
          contentWidth <= 375
            ? 1
            : contentWidth >= 1280
              ? 3
              : 1 + (contentWidth - 375) / (1280 - 375);

        // Calculate the scrolling speed with the adjusted slowFactor
        const scrollingDuration = (
          (scrollingSpeed *
            slowFactor *
            entries[0].target.querySelector("span").clientWidth) /
          contentWidth
        ).toFixed(3);

        this.style.setProperty("--bullet-speed", `${scrollingDuration}s`);
      }
    },
  );

/*** init app */
function app() {
  getSetVh(); // get Viewport Height
  toggleMenu(); // toggle Menu
  toggleCart(); // toggle Cart
  closeFilters();
  initializeDetailsControls(); // call details
}

/*** on DOM ready **/
document.addEventListener("DOMContentLoaded", () => {
  app();
});
